import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import NewsletterSignup from "./NewsletterSignup";

function Home() {
  const [homeDoc, setHomeDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHome = async () => {
      try {
        const snap = await getDoc(doc(db, "pages", "home"));
        setHomeDoc(snap.exists() ? snap.data() : null);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };
    fetchHome();
  }, []);

  console.log("Home page data:", { homeDoc, loading, error });

  return (
    <div className="bg-background-light dark:bg-background-dark px-4 sm:px-6 py-12">
      <div className="max-w-4xl mx-auto text-center">
        {loading ? (
          <div className="flex justify-center items-center">
            <div
              className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"
              aria-label="Loading"
            />
          </div>
        ) : error ? (
          <p className="text-error text-center">Error: {error.message}</p>
        ) : (
          <>
            <h1 className="text-4xl sm:text-5xl font-bold text-text-light dark:text-text-dark mb-6">
              {homeDoc?.title || "Welcome to 66 Days Journal"}
            </h1>
            <p className="text-lg text-neutral mb-8">
              {homeDoc?.description ||
                "Transform your life in just 66 days. Our journaling app guides you through daily reflections, inner child work, and habit tracking to build resilience and foster personal growth."}
            </p>
          </>
        )}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Link to="/cycles" className="btn-primary text-lg px-6 py-3">
            Start Journaling
          </Link>
          <Link to="/newsletter" className="btn-secondary text-lg px-6 py-3">
            Join Our Newsletter
          </Link>
        </div>
        <div className="card p-6 mb-12">
          <h2 className="text-2xl font-semibold text-text-light dark:text-text-dark mb-4">
            Why 66 Days?
          </h2>
          <p className="text-neutral">
            Research shows it takes about 66 days to form a new habit. Our app provides structured prompts, tasks, and inner child exercises to help you create lasting change. Whether you're healing past wounds or building new habits, we're here to support your journey.
          </p>
        </div>
        <NewsletterSignup />
      </div>
    </div>
  );
}

export default Home;